import { occupantsColumns } from 'common/list-configs/occupants.config';
import { occupantsEIQManageColumns } from '../../../../../list-config/occupants.config';

const { name, ownershipType, hostName, hostOwnershipType } = occupantsColumns();
const { isSharedGuestList, isSharedVehiclesList } = occupantsEIQManageColumns();
export const occupantsInitialColumns = [name, ownershipType, hostName, hostOwnershipType, isSharedGuestList, isSharedVehiclesList];
